<template>
  <section class="lk-step">
    <h2
      class="lk-q"
      tabindex="-1"
    >
      Im Alter von … bis …
    </h2>
    <div class="range-values">
      <span>
        <strong>{{ ageMin }}</strong>
        <span class="lbl">Jahre</span>
      </span>
      <span>
        <span class="lbl">bis</span>
        <strong>{{ ageMax }}</strong>
        <span class="lbl">Jahre</span>
      </span>
    </div>
    <div class="range-track">
      <div
        class="range-fill"
        :style="rangeFillStyle"
      ></div>
      <input
        type="range"
        :min="ageSliderMin"
        :max="ageSliderMax"
        :value="ageMin"
        step="1"
        aria-label="Mindestalter"
        @input="onAgeMin"
      />
      <input
        type="range"
        :min="ageSliderMin"
        :max="ageSliderMax"
        :value="ageMax"
        step="1"
        aria-label="Höchstalter"
        @input="onAgeMax"
      />
    </div>
  </section>
</template>

<script>
import { AGE_SLIDER_MAX, AGE_SLIDER_MIN } from '../kennenlernenLeadFunnel';

export default {
  name: 'LeadFunnelStepAgeRange',
  props: {
    ageMin: { type: Number, required: true },
    ageMax: { type: Number, required: true },
  },
  data() {
    return {
      ageSliderMin: AGE_SLIDER_MIN,
      ageSliderMax: AGE_SLIDER_MAX,
    };
  },
  computed: {
    rangeFillStyle() {
      const span = AGE_SLIDER_MAX - AGE_SLIDER_MIN;
      const a = (this.ageMin - AGE_SLIDER_MIN) / span;
      const b = (this.ageMax - AGE_SLIDER_MIN) / span;
      return {
        left: 'calc(12px + (100% - 24px) * ' + a + ')',
        right: 'calc(12px + (100% - 24px) * ' + (1 - b) + ')',
      };
    },
  },
  methods: {
    onAgeMin(e) {
      this.$emit('update:ageMin', Math.min(+e.target.value, this.ageMax));
    },
    onAgeMax(e) {
      this.$emit('update:ageMax', Math.max(+e.target.value, this.ageMin));
    },
  },
};
</script>
